import Vue from 'vue'
import App from './app/App.vue'
import './registerServiceWorker'
import router from './router/index.js'
import store from './store'
import Axios from 'axios'
import Vuelidate from "vuelidate/src";
import VueAuthenticate from 'vue-authenticate'
import VueClipboard from 'vue-clipboard2'
import moment from 'moment';
import VueMoment from 'vue-moment';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
import VModal from 'vue-js-modal'

Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#454545',
  background: '#ffffff',
  borderRadius: 4,
  fontWeight: 400,
})
Vue.use(VModal)
Vue.use(VueClipboard);
Vue.use(Vuelidate)

Vue.use(VueMoment, { moment });
Vue.config.productionTip = false
Vue.prototype.$http = Axios;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
